import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './PriceUsdEuro.css';

class PriceUsdEuro extends React.Component {
  static propTypes = {
    usd: PropTypes.string,
    eur: PropTypes.string,
    uah: PropTypes.string,
  };

  static defaultProps = {
    uah: '',
    usd: '',
    eur: '',
  };

  render() {
    const prices = [];
    ['uah', 'usd', 'eur'].forEach(key => {
      if (this.props[key]) prices.push(key);
    });

    return (
      <div className={s.root}>
        {prices.map((key, idx) =>
          <span key={key} data-currency={key} className={s.currency}>
            {this.props[key]} {idx !== prices.length - 1 ? ' • ' : ''}
          </span>,
        )}
      </div>
    );
  }
}

export default withStyles(s)(PriceUsdEuro);



// WEBPACK FOOTER //
// ./src/shared/components/PriceUsdEuro/PriceUsdEuro.js